<div class="text-group" [formGroup]="form">
  <div class="text-container">
    <label [for]="settings.idName" [ngClass]="{ 'text-danger': errorMessage }"
      >{{ settings.label }}
    </label>
    <tooltip
      [title]="'Enter Your ' + settings.label"
      placement="right"
      delay="200"
    ></tooltip>
    <input
      type="text"
      id="settings.idName"
      restrict-input
      formControlName="numberInput"
      [placeholder]="settings.placeholder"
      [name]="settings.name"
      [readonly]="settings.readOnly"
      [class.valid]="form.value.numberInput"
      [class]="settings.className"
      [ngClass]="{ 'border-danger': errorMessage }"
      [maxlength]="settings.maxlength"
      (change)="valueChange()"
      (focus)="onFocusEvent($event)"
      (click)="onClickEvent($event)"
      (blur)="onBlurEvent($event)"
      (keyup.enter)="onEnterEvent($event)"
    />
    <span class="highlight"></span>
    <span class="bar"></span>
  </div>
  <div class="clearfix"></div>
</div>
<p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
